import React from 'react'
import MainContentsWithSidebarInbox from 'components/templates/MainContentsWithSidebarInbox'
import ModalSelect from 'components/organisms/ModalSelect'
import LoadingView from 'components/atoms/LoadingView'

type PropTypes = {
  sidebarComponent: ?any,
  isShowContentsSp?: ?boolean,
  isLoading?: ?boolean,
}

export default function ReservationChangeHostPage(props: PropTypes) {
  return (
    <React.Fragment>
      <MainContentsWithSidebarInbox
        sidebarInbox={props.sidebarComponent}
        isShowContentsSp={props.isShowContentsSp}
      >
        {props.children}
      </MainContentsWithSidebarInbox>
      {props.isLoading && <LoadingView />}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/pages/ReservationChangeGuestPage/index.jsx